<template>
    <div class="ContactPage">
        <SiteHeader/>

        <Container>
            <form v-if="!isSubmitted" @submit.prevent="handleSubmit">
                <h1>Contact Us</h1>
                <p>Send us a message and we'll get back to you ASAP.</p>

                <FormInput
                    v-model="$v.name.$model"
                    lazy
                    label="Name"
                    :errors="$v.name.$error ? [
                        !$v.name.required && 'Name is required',
                    ] : null"
                />
                <FormInput
                    v-model="$v.email.$model"
                    lazy
                    label="Email"
                    :errors="$v.email.$error ? [
                        !$v.email.required && 'Email is required',
                        !$v.email.email && 'Has to be valid email address',
                    ] : null"
                />

                <FormTextarea
                    v-model="$v.message.$model"
                    lazy
                    label="Message"
                    :errors="$v.message.$error ? [
                        !$v.message.required && 'Message is required',
                    ] : null"
                />

                <Button class="primary lg" type="submit" :disabled="submitPending">Submit</Button>
            </form>
            <div v-else>
                <h1>Thank you!</h1>
                <p>We received your email, you will hear back from us soon.</p>
            </div>

            <div class="supportList">
                <div class="supportItem">
                    <h2>Email Support</h2>
                    <div>
                        <Icon name="envelope"/>
                        <strong>
                            <span>United States</span>
                            <a href="mailto:info@dumptek.com">info@dumptek.com</a>
                        </strong>
                    </div>
                </div>
                <div class="supportItem">
                    <h2>Phone Support</h2>
                    <div>
                        <Icon name="phone"/>
                        <strong>
                            <span>United States</span>
                            <a href="tel:8007735612">(800) 773-5612</a>
                        </strong>
                    </div>
                </div>
            </div>
        </Container>

        <SiteFooter/>
    </div>
</template>

<script>
import * as api from '@/api';
import { required, email } from 'vuelidate/lib/validators';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';

export default {
    name: 'ContactPage',

    data: () => ({
        name: null,
        email: null,
        message: null,

        submitPending: false,
        isSubmitted: false,
    }),

    validations: {
        name: {
            required,
        },
        email: {
            required,
            email,
        },
        message: {
            required,
        },
    },

    components: {
        SiteHeader,
        SiteFooter,
    },

    methods: {
        async handleSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            if (this.submitPending) return;
            this.submitPending = true;

            const { name, email, message } = this;
            const res = await api.sendNewContactMail({ name, email, message });
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Failed to submit contact form.');
            }

            this.$awn.success('Email sent!');
            this.isSubmitted = true;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ContactPage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        text-align: center;
        margin-bottom: 80px;
    }

    .SiteFooter {
        align-self: flex-end;
    }

    h1 {
        @extend %display-subtitle;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    p {
        @extend %display-description;
        margin-bottom: 40px;
    }

    form {
        max-width: 600px;
        margin: 40px auto;
    }

    h2 {
        margin-top: 80px;
    }

    .supportList {
        display: flex;
        justify-content: center;

        @include breakpoint(sm) {
            flex-direction: column;
        }
    }

    .supportItem {
        margin: 15px 30px;

        & > div {
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        span {
            display: block;
            text-align: left;
        }

        .Icon {
            margin-right: $grid-gutter-width;
            font-size: 36px;
        }

        @include breakpoint(sm) {
            margin: 0 auto;
        }
    }
}
</style>
